import { UserFriendlyError } from '@affine/error';
import type { I18nFuncs } from '@affine/i18n';

export function getTwoFactorVerificationErrorMessage(
  error: unknown,
  t: I18nFuncs
) {
  const friendly = UserFriendlyError.fromAny(error);

  if (friendly.isNetworkError() || friendly.isStatus(504)) {
    return t['com.streamlain.moderation.error.offline.message']();
  }

  return t['com.streamlain.auth.sign.auth.code.invalid']();
}
